import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';
import type { TranslationKey } from '../translations';

export function useTranslation() {
  const { language } = useLanguage();
  
  const t = (key: TranslationKey) => {
    return translations[language][key];
  };
  
  return { t };
}